import axios from "axios";
import customLocalStorage from "./local-storage";
import decrypt from "./decrypt-data";

const apiRequest = async (params) => {
  const { url, data, callBack, dataName, method } = params;
  let config = {
    method,
    url,
    data,
  };

  if (url.search("/login") === -1) {
    const user = customLocalStorage.decrypt("iwmUser");
    if (user) {
      config.headers = {
        Authorization: `JWT ${user?.access}`,
        "Content-Type": "application/json",
      };
    }
  }

  await axios(config)
    .then((res) => {
      console.log(res)
      if (res?.data?.error) {
        return callBack({
          data: res?.data?.error,
          dataName,
          severity: "error",
          status: res?.request?.status,
        });
      }
      const shouldDecrypt = typeof res?.data === "string";
      const data = shouldDecrypt ? decrypt(res?.data) : res?.data;
      return callBack({
        data,
        dataName,
        severity: "success",
        status: res?.request?.status,
      });
    })
    .catch((err) => {
      console.log(err)
      const data =
        err?.response?.data?.message ||
        err?.response?.data?.detail ||
        err?.response?.data?.details ||
        err?.message;
      return callBack({
        data,
        dataName,
        severity: "error",
        status: err?.response?.status,
      });
    });
};
export default apiRequest;
